import axios from "axios";
import { API_URL } from "../../const";

/*************** STAFF DETAILS ADD START *************** */
export const staffDetailsAdd = (addData: any) => {
  const data = {
    CreateUserLoginToken: addData,
  };
  const url = `${API_URL}CreateUser`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS ADD END *************** */

/*************** STAFF DETAILS UPDATE START *************** */
export const staffDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateUserLoginToken: updateData,
  };
  const url = `${API_URL}UpdateLoginUser`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS UPDATE END *************** */

/*************** STAFF DETAILS GET START *************** */
export const staffListGet = (listData: any) => {
  const data = {
    GetAllUserPaginationToken: listData,
  };
  const url = `${API_URL}GetAllUserPaginationDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS GET END *************** */

/*************** STAFF DETAILS FETCH START *************** */
export const staffDetailsFetch = (fetchData: any) => {
  const data = {
    FetchUserLoginToken: fetchData,
  };
  const url = `${API_URL}FetchUserDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS FETCH END *************** */

/*************** STAFF DETAILS DELETE START *************** */
export const staffDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteUserLoginToken: deleteData,
  };
  const url = `${API_URL}DeleteUserLogin`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS DELETE END *************** */

/*************** BRANCH LILST  DETAILS DELETE START *************** */
export const branchListDetails = (deleteData: any) => {
  const data = {
    GetAllBranchToken: deleteData,
  };
  const url = `${API_URL}GetAllBranchDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DETAILS DELETE END *************** */

/*************** USERTYPE DETAILS LIST   START *************** */
export const userTypeListDetails = (deleteData: any) => {
  const data = {
    GetAllUserTypeToken: deleteData,
  };
  const url = `${API_URL}GetAllUserTypeDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** USERTYPE DETAILS DELETE END *************** */

/*************** STAFF  DEPARTMENT DETAILS LIST START *************** */
export const departmentDropdownListDetails = (deleteData: any) => {
  const data = {
    GetAllDepartmentToken: deleteData,
  };
  const url = `${API_URL}GetAllDepartmentDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** STAFF DEPARTMENT DETAILS LIST END *************** */

/***************  MANAGER DETAILS LIST START *************** */
export const managerDropdownListDetails = (deleteData: any) => {
  const data = {
    GetAllManagerDetailsToken: deleteData,
  };
  const url = `${API_URL}GetAllManagerDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/***************  MANAGER DETAILS LIST END *************** */
